import "./styles.scss";
import Heading from "./Heading";
import "./styles.scss";
import { Modal, Row, Table } from "antd";
import { IconList } from "../../../constants/imageList";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserList,
  suspendUser,
  unSuspendUser,
} from "../../../appConfig/redux/reducer/userManagement.reducer";
import { useEffect, useState } from "react";
import {
  EyeOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons/lib/icons";
import { DeleteOutlined } from "@ant-design/icons";
import { userManagementActions } from "../../../appConfig/redux/slice/userManagement.slice";
import { SCREEN_PATHS } from "../../../constants";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const NeighbourManagement = () => {
  const navigate = useNavigate();
  const [isSuspended, setIsSuspended] = useState();

  const [isPopup, setIsPopup] = useState(false);
  const [user, setUser] = useState();

  const columns = [
    {
      title: "User name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => {
        return a.name.localeCompare(b.name);
      },
      render: (text) => {
        return <p>{text}</p>;
      },
    },

    {
      title: "Email address",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => {
        return a.email.localeCompare(b.email);
      },
      render: (text) => {
        return <p className="email">{text}</p>;
      },
    },
    {
      title: "User type",
      dataIndex: "userType",
      key: "userType",

      render: (text) => {
        return (
          <p className="address">
            {text?.length > 80 ? `${text.slice(0, 80)}...` : text}
          </p>
        );
      },
    },
    {
      title: "Joined date",
      dataIndex: "createdOn",
      key: "createdOn",
      sorter: (a, b) => {
        return moment(a.createdOn).unix() - moment(b.createdOn).unix();
      },
      render: (text) => {
        return <p>{text}</p>;
      },
    },
    {
      title: "Actions",
      dataIndex: "userId",
      key: "userId",
      render: (text) => {
        return (
          <Row justify={"space-around"}>
            <EyeOutlined
              style={{ fontSize: 20 }}
              onClick={() => {
                const user = userList.find((item) => item.userId == text);
                dispatch(userManagementActions.setSelectedUser(user));
                navigate(SCREEN_PATHS.userDetail);
              }}
            />
            {userList.find((item) => item.userId == text).isApproved ===
            "suspended" ? (
              <UserAddOutlined
                style={{ fontSize: 20 }}
                onClick={() => {
                  const user = userList.find((item) => item.userId == text);
                  console.log(user);
                  setUser(user);
                  setIsSuspended(true);
                  setIsPopup(true);
                }}
              />
            ) : (
              <UserDeleteOutlined
                style={{ fontSize: 20 }}
                onClick={() => {
                  const user = userList.find((item) => item.userId == text);
                  console.log(user);
                  setUser(user);
                  setIsSuspended(false);
                  setIsPopup(true);
                }}
              />
            )}
          </Row>
        );
      },
    },
  ];
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // dispatch(requestListActions.setSelectedRequest(selectedRows));
    },
    type: "checkbox",
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getUserList({
        params: {
          type: "Neighbour",
        },
      })
    );
  }, []);
  const { userList } = useSelector((state) => state.userManagement);
  return (
    <div className="user-management-container">
      <Heading />
      <div className="table">
        <Table
          size="middle"
          // rowSelection={rowSelection}
          columns={columns}
          dataSource={userList ?? []}
        />
      </div>
      <Modal
        open={isPopup}
        onCancel={() => setIsPopup(false)}
        onOk={() => {
          isSuspended
            ? dispatch(
                unSuspendUser({
                  value: {
                    email: user.email,
                    userType: "neighbours",
                  },
                  callback: () => {
                    setIsPopup(false);
                    dispatch(
                      getUserList({
                        params: {
                          type: "Neighbour",
                        },
                      })
                    );
                  },
                })
              )
            : dispatch(
                suspendUser({
                  value: {
                    email: user.email,
                    userType: "neighbours",
                  },
                  callback: () => {
                    setIsPopup(false);
                    dispatch(
                      getUserList({
                        params: {
                          type: "Neighbour",
                        },
                      })
                    );
                  },
                })
              );
        }}
      >
        <p>
          Do you want to {isSuspended ? "approve" : "temporarily suspend"} the
          user?
        </p>
      </Modal>
    </div>
  );
};
export default NeighbourManagement;
